import { render, staticRenderFns } from "./SidebarFilters.vue?vue&type=template&id=2e45c0ab"
import script from "./SidebarFilters.vue?vue&type=script&lang=js"
export * from "./SidebarFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports